// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"58812ae49e2c2a4950c1","532":"8cb3df583a7fca2e253a","691":"7b23929eea19bd49040e"}[chunkId] + ".js";
};